import { ChangeEvent } from 'react';

import { TextField } from '@atom/mui';

import classes from '../../formInstance.module.css';

interface PassedProps {
  type: string;
  value: any;
  isEditable: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

type Props = PassedProps;

const TextAttribute = ({ type, value, onChange, isEditable }: Props) => {
  return (
    <div className={classes.attributeInput}>
      <TextField
        variant="standard"
        name={type}
        onChange={onChange}
        value={value}
        disabled={!isEditable}
        multiline={type === 'longtext'}
      />
    </div>
  );
};

export default TextAttribute;
